
import Vue from 'vue'
import Vuex from 'vuex'
import {storeEvent} from '_shared/Event/store'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    client_id: 'webapp.client',  
    coloredHeader:['Live', 'WaitingRoom']  
  },
  modules:{
    event:storeEvent
  }
});